module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.showDeletePromotionModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Delete Group")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.deleted) ? _c('div', {
    key: "a"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n\t\t\t\t\tAre you sure you want to delete this group?\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.deleted) ? _c('div', {
    key: "b"
  }, [_c('div', {
    staticClass: "swal2-icon swal2-success swal2-animate-success-icon",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "swal2-success-circular-line-left",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-tip swal2-animate-success-line-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-long swal2-animate-success-line-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-ring"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-fix",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-circular-line-right",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  })])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer clear",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.deleted),
      expression: "!deleted"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteGroup()
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleted),
      expression: "deleted"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteGroupAndCloseModal()
      }
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1687816c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UserManager/DeleteUserGroup.vue
// module id = 675
// module chunks = 0